import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { productTypeList } from 'global/Models/productTypeModel';
import ApiService from 'global/utils/ApiService';
import { setCustomerProductTypes } from 'redux/reducer/ParcelOrder/parcelOrderReducer';
import { AppDispatch } from 'redux/store';

export const getCustomerProductTypes = (customerPackageId?: number) => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.customerProductList, { recordsPerPage: 50, customerPackageId })
    .then((res: IBackendSearchGeneric<productTypeList>) => {
      res.isSuccess && dispatch(setCustomerProductTypes(res.data));
    })
    .catch(() => {});
};
